export default "__VITE_ASSET__Bph1PWoU__"